import PlataformasForm from "./PlataformasForm";
export default PlataformasForm;